import {
  ANTHROPIC_FABLE_5_1_MODEL_REF,
  ANTHROPIC_FABLE_5_MODEL_REF,
} from "./anthropic";
import {
  BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF,
  BEDROCK_ANTHROPIC_FABLE_5_MODEL_REF,
} from "./bedrockAnthropic";

export const BEDROCK_CONVERSE_FABLE_5_MODEL_ID =
  "global.anthropic.claude-fable-5";
export const BEDROCK_CONVERSE_FABLE_5_MODEL_REF =
  "bedrock/global.anthropic.claude-fable-5";

export const BEDROCK_CONVERSE_FABLE_5_1_MODEL_ID =
  "global.anthropic.claude-fable-5-1";
export const BEDROCK_CONVERSE_FABLE_5_1_MODEL_REF =
  "bedrock/global.anthropic.claude-fable-5-1";

/** The three routes Claude Fable 5.1 is reachable on. */
export const CLAUDE_FABLE_5_1_MODEL_REFS = [
  ANTHROPIC_FABLE_5_1_MODEL_REF,
  BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF,
  BEDROCK_CONVERSE_FABLE_5_1_MODEL_REF,
] as const;

export type ClaudeFable51ModelRef =
  (typeof CLAUDE_FABLE_5_1_MODEL_REFS)[number];

/** The six Fable model refs (both generations, all three routes). */
export const CLAUDE_FABLE_MODEL_REFS = [
  ANTHROPIC_FABLE_5_MODEL_REF,
  BEDROCK_ANTHROPIC_FABLE_5_MODEL_REF,
  BEDROCK_CONVERSE_FABLE_5_MODEL_REF,
  ...CLAUDE_FABLE_5_1_MODEL_REFS,
] as const;

export type ClaudeFableModelRef = (typeof CLAUDE_FABLE_MODEL_REFS)[number];

const FABLE_5_1_REF_SET: ReadonlySet<string> = new Set(
  CLAUDE_FABLE_5_1_MODEL_REFS,
);
const FABLE_REF_SET: ReadonlySet<string> = new Set(CLAUDE_FABLE_MODEL_REFS);

/** Exact match on one of the three Fable 5.1 model refs. */
export function isClaudeFable51ModelRef(
  modelRef: string | null | undefined,
): modelRef is ClaudeFable51ModelRef {
  const trimmed = modelRef?.trim();
  return trimmed !== undefined && FABLE_5_1_REF_SET.has(trimmed);
}

/** Exact match on one of the six Fable model refs (5 or 5.1). */
export function isClaudeFableModelRef(
  modelRef: string | null | undefined,
): modelRef is ClaudeFableModelRef {
  const trimmed = modelRef?.trim();
  return trimmed !== undefined && FABLE_REF_SET.has(trimmed);
}
